<div *ngIf="label" class="label">{{label}}</div>
<div [id]="_id">{{ this._ngModel }}</div>
